/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import InjectableComponent from '../Utility/Component/ComponentReference/InjectableComponent';
import LayerManager from '../Utility/Component/LayerManager';
import Effect from './Effect';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

export enum ActionType
{
    Execute = 0,
    Clear = 1,
}

// tslint:disable-next-line:typedef
let ccActionType = cc.Enum(ActionType);
export { ccActionType };

@cc._decorator.ccclass
export default class LayerManagerEffect extends Effect
{
    @property({ type: ccActionType })
    protected action: ActionType = ActionType.Execute;

    @property(InjectableComponent)
    protected layerManagerRef: InjectableComponent<LayerManager> = new InjectableComponent();

    protected setContexts(): void
    {
        this.layerManagerRef.SetContext(LayerManager);
    }

    protected trigger = (): void =>
    {
        if (!this.layerManagerRef.Value) { return; }

        switch (this.action)
        {
            case ActionType.Execute:
                this.layerManagerRef.Value.Execute();
                break;
            case ActionType.Clear:
                this.layerManagerRef.Value.Clear();
                break;
            default:
                break;
        }

        this.complete();
    }
}
